import React, { useEffect, useState } from "react";
import {  Col,  Form,  Input,  Modal,  DatePicker,  theme,  Row,  Divider,  Space, Select ,} from "antd";
import { PATCH, POST } from "../../frameworks/HttpClient";
import { URL_SETTING, URL_SKIM } from "../../constants/urls";
import ErrorMessages from "../../common/ErrorMessages";
import { PRIMARY_COLOR } from "../../constants/color";

export default function CloseLotSkimModal(props) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { open, onClose, target, onUpdate } = props;
  const [errorMessages, setErrorMessages] = useState(null);
  const { RangePicker } = DatePicker;

  useEffect(() => {
    setErrorMessages(null)
    if (target) {
      form.resetFields();
    }
  }, [open]);

  const {
    token: { colorWarning, colorSuccess },
  } = theme.useToken();

  const handleOK = async () => {
    setLoading(true);
    setErrorMessages(null);
    try {
      const data = await form.validateFields();
      data['action'] = "close"
      if (target?.id) {
        await POST(`${URL_SKIM.SKIM_TRANSACTION}${target.id}/change-state/`, data);
      } else {
        await POST(URL_SETTING.POND, data);
      }
      onUpdate();
    } catch (error) {
      setErrorMessages(error.errorMessages);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      okText={"ยืนยัน"}
      cancelText="ยกเลิก"
      title={"หยุดเติมน้ำยาง"}
      width={420}
      onOk={handleOK}
      destroyOnClose
      okButtonProps={{
        style: { backgroundColor: PRIMARY_COLOR },
        loading,
      }}
    >
      <ErrorMessages message={errorMessages} />

      <Form form={form} layout="vertical">
        <Row gutter={10}>
          <Form.Item
            label="วันที่จบ"
            name="end_datetime"
            rules={[{  required: true, message : 'กรุณากรอกข้อมูล'}]}
            style={{ width: '100%' }}
          >
            <DatePicker 
              showTime={{
                format: "HH:mm",
              }}
              format="YYYY-MM-DD HH:mm"
              style={{ width : '100%' }} 
              placeholder="วันที่จบ"
            />
          </Form.Item>
        </Row>
      </Form>
    </Modal>
  );
}
